import classNames from 'classnames';
import { MSImage } from 'common/image/ms-image.js';
import { LinkFactoryReactRouter } from 'common/link/link-react-router.js';
import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { IModule } from 'redux-state/layout/types.js';
import { getWindowLocation } from 'utilities/window.js';

interface ILinkItem {
  label: string;
  link: string;
  img: string;
}

export interface IImageTileListImageConfig {
  items: Array<ILinkItem>;
}

export const ImageTileList = ({ config, modulePath, isDrawer }: IModule<IImageTileListImageConfig>) => {
  const { items } = config;

  const pathname = getWindowLocation().pathname;

  const renderedItems = items.map(({ label, link, img }, i) => {
    const linkClasses = classNames('ImageTileList-item u-linkClean u-textBlack', {
      'is-active': pathname === link,
    });

    return (
      <li key={i}>
        <LinkFactoryReactRouter href={link} className={linkClasses}>
          <MSImage src={img} classes="ImageTileList-item-img" alt={`${label} image`} />
          <h3 className="u-pL-md u-pR-md">{label}</h3>
        </LinkFactoryReactRouter>
      </li>
    );
  });

  return (
    <Tile dataModule="image-tile-list-mod" config={config} classes="figure-ratio-465-601">
      <div className="Tile-body">
        <TileBodyHeaderV2 config={config} modulePath={modulePath} isDrawer={isDrawer} />
        <ul className="ImageTileList-list">{renderedItems}</ul>
      </div>
    </Tile>
  );
};
